import { useDispatch, useSelector } from "react-redux";
import style from "./SilenceRules.module.css"
import AlertService from "../../services/AlertService";
import { setModalError } from "../../store/reducers/modalReducer";
import { sha256 } from "js-sha256";
import {
    deselectSilenceRule,
    selectSilenceRule,
    setEditRule,
    setOpenSilenceRules,
    setSilenceRules,
} from "../../store/reducers/silenceRulesReducer";
import { Fragment, useEffect } from "react";
import { processAlertComment } from "../../utils/utils";
import { formatSilenceDuration } from "../../utils/silenceDuration";


function SilenceRules() {
    const dispatch = useDispatch();
    const silenceRules = useSelector(state => state.setSilenceRules.rules)
    const selectedRules = useSelector(state => state.setSilenceRules.selectedSilenceRules)
    const user = useSelector(state => state.authReducer.user)
    const selectedSilenceRules = useSelector(state => state.setSilenceRules.selectedSilenceRules)

    useEffect(() => {
        const fetchSilencedRules = async () => {
            const rules = []
            try {
                const response = await AlertService.getSileneced()
                response.data.forEach((rule) => {
                    rules.push(rule)
                })
            }
            catch (e) {
                dispatch(setModalError("Oops. Something went wrong. Please, try a bit later"))
            }
            dispatch(setSilenceRules(rules))
        }

        fetchSilencedRules()
    }, [])

    const refreshRules = async () => {
        const newRules = []
        try {
            const response = await AlertService.getSileneced()
            response.data.forEach((rule) => {
                newRules.push(rule)
            })
        }
        catch (e) {
            dispatch(setModalError("Oops. Something went wrong. Please, try a bit later"))
        }
        dispatch(setSilenceRules(newRules))
    }

    const onDeleteAlertButton = async (id) => {
        try {
            await AlertService.unsilence([{ silenceId: id }])
        }
        catch (e) {
            dispatch(setModalError("Oops. Something went wrong. Please, try a bit later"))
        }

        refreshRules()

    }

    const onEditHandler = (id, project, host, alert, duration, comment, labels) => {
        const editRule = {
            _id: id,
            project: project,
            host: host,
            alertName: alert,
            duration: duration,
            comment: comment,
            labels: labels,
        }

        dispatch(setEditRule(editRule))

        dispatch(setOpenSilenceRules())
    }

    const renderComment = (comment) => {
        if (!comment) {
            return null
        }

        return comment.split(/\s+/).map((word, index) => (
            <Fragment key={`${word}-${index}`}>
                {processAlertComment(word, user?.usersCommentReplaceRules)}{" "}
            </Fragment>
        ))
    }

    const onRuleCheckboxChange = (id) => {
        if (selectedSilenceRules.includes(id)) {
            dispatch(deselectSilenceRule(id))
        } else {
            dispatch(selectSilenceRule(id))
        }
    }

    const onSelectAllRules = () => {
        if (selectedSilenceRules.length === 0) {
            silenceRules.forEach(rule => {
                dispatch(selectSilenceRule(rule._id))
            })
        } else {
            selectedSilenceRules.forEach(ruleId => {
                dispatch(deselectSilenceRule(ruleId))
            })
        }
    }

    return (
        <div className={style.page}>
            <table className={style.table}>
                <thead className={style.header}>
                    <tr>
                        <th scope="col" className={`${style.headerElement} ${style.authorColumn}`}>
                            <label className={style.checkBoxLabel}>
                                <input
                                    className={style.selectCheckBox}
                                    type="checkbox"
                                    onChange={onSelectAllRules}
                                    checked={selectedSilenceRules.length > 0}
                                />
                                <span>Author</span>
                            </label>
                        </th>
                        <th scope="col" className={`${style.headerElement} ${style.column}`}>Project</th>
                        <th scope="col" className={`${style.headerElement} ${style.column}`}>Host</th>
                        <th scope="col" className={`${style.headerElement} ${style.alertColumn}`}>Alert Name</th>
                        <th scope="col" className={`${style.headerElement} ${style.column}`}>Till</th>
                        <th scope="col" className={style.headerElement}>Comment</th>
                        <th scope="col" className={`${style.headerElement} ${style.actionsColumn}`}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {silenceRules && silenceRules.length > 0 ?
                        (silenceRules.map((rule) => (
                            <tr key={rule._id}>
                                <td className={`${style.authorColumn} ${style.cell}`}>
                                    <div className={`${style.flexCell} ${style.authorCell}`}>
                                        <label className={style.checkBoxLabel}>
                                            <input
                                                className={style.selectCheckBox}
                                                type="checkbox"
                                                onChange={() => onRuleCheckboxChange(rule._id)}
                                                checked={selectedSilenceRules.includes(rule._id)}
                                            />
                                        </label>
                                        <img className={style.authorIcon} src={`https://gravatar.com/avatar/${sha256(rule.author)}?s=150)`} alt={rule.author} />
                                    </div>
                                </td>
                                <td className={style.cell}>
                                    <p className={style.textCell}>{rule.project ? rule.project : "*"}</p>
                                </td>
                                <td className={style.cell}>
                                    <p className={style.textCell}>{rule.host ? rule.host : "*"}</p>
                                </td>
                                <td className={style.cell}>
                                    <p className={style.textCell}>{rule.alertName ? rule.alertName : "*"}</p>
                                </td>
                                <td className={style.cell}>
                                    <p className={style.textCell}>{rule.endSilence !== null
                                        ? new Date(parseInt(rule.endSilence, 10)).toLocaleString()
                                        : "permanent"
                                    }</p>
                                </td>
                                <td className={style.cell}>
                                    <p className={style.textCell}>{renderComment(rule.comment)}</p>
                                </td>
                                <td className={style.cell}>
                                    <div className={style.flexCell}>
                                        <button className={style.button}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let duration
                                                if (rule.endSilence !== null) {
                                                    duration = formatSilenceDuration(rule.endSilence)
                                                } else {
                                                    duration = ""
                                                }
                                                onEditHandler(
                                                    rule._id,
                                                    rule.project,
                                                    rule.host,
                                                    rule.alertName,
                                                    duration,
                                                    rule.comment,
                                                    rule.labels || {}
                                                )
                                            }}
                                        >
                                            Edit
                                        </button>
                                        <button className={style.button}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                onDeleteAlertButton(rule._id)
                                            }}>
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )))
                        : null
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SilenceRules;
